declare global {
  interface Window {
    gaEventManager: GaEventManager;
  }
}

/**
 * Handles all the Google Analytics events.
 *
 * Until GA is initialized, it will simply queue all the calls, and, as soon as
 * GA gets initialized, send them all.
 */
export class GaEventManager {
  private queue: Array<UniversalAnalytics.FieldsObject> = [];
  private loaded = false;
  private trackerName: string | null = null;

  /**
   * Queue or immediately send a GA event.
   *
   * @param category the event category
   * @param action the event action
   * @param label the event label
   * @param value the event value
   */
  public push(
    category: string,
    action: string,
    label?: string,
    value?: number
  ): void {
    const eventParams: UniversalAnalytics.FieldsObject = {
      hitType: "event",
      eventCategory: category
    };

    if (action) {
      eventParams.eventAction = action;
    }
    if (label) {
      eventParams.eventLabel = label;
    }
    if (value) {
      eventParams.eventValue = value;
    }

    if (this.loaded && typeof ga === "function") {
      this.sendEvent(eventParams);
    } else {
      this.queue.push(eventParams);
    }
  }

  /**
   * Send all the queued GA events.
   */
  public unstack(): void {
    this.loaded = true;
    this.queue.forEach(event => this.sendEvent(event));
  }

  /**
   * Send a GA event using the GTM-defined GA instance.
   * @param eventParams the event parameters
   */
  private sendEvent(eventParams: UniversalAnalytics.FieldsObject): void {
/*
TODO : NO MORE UA : to be replaced with GTM if needed

  if (!this.trackerName) {
      ga(() => {
        const tracker = ga.getAll()[0];
        this.trackerName = tracker.get("name");
        ga(`${this.trackerName}.send`, eventParams);

      });

      return;
    }

    ga(`${this.trackerName}.send`, eventParams);
*/
  }
}
